import { SITES_ROOT, api, API_V2, CUSTOMERS } from '../api';
import { GetAllParamsTypes } from './types';

export type dataSourceParamsType = {
  dataSourceType?: 'streametric_ai' | 'weather_api' | 'integralert';
};

const add = async (customerId: string, siteId: string, params: dataSourceParamsType) => {
  const response = await api({
    method: 'post',
    url: `${SITES_ROOT}/${customerId}${SITES_ROOT}/${siteId}/data/sources`,
    params,
  });

  return response.data;
};

const addIntegralert = async (
  customerId: string,
  siteId: string,
  data: { sensorGatewayKey: string; dataSourceName: string; payloadInterval: number }
) => {
  const response = await api({
    method: 'post',
    url: `${API_V2}/${CUSTOMERS}/${customerId}/data-sources/integralert`,
    data: { siteId, ...data },
  });

  return response.data;
};

const getAll = async (customerId: string, siteId: string, params?: GetAllParamsTypes) => {
  const response = await api({
    method: 'get',
    url: `${SITES_ROOT}/${customerId}${SITES_ROOT}/${siteId}/data/sources`,
    params,
  });

  return response.data;
};

const getById = async (customerId: string, siteId: string, dataSourceId: string) => {
  const response = await api({
    method: 'get',
    url: `${SITES_ROOT}/${customerId}${SITES_ROOT}/${siteId}/data/sources/${dataSourceId}`,
  });

  return response.data;
};

const edit = async (data: any, customerId: string, siteId: string, dataSourceId: string) => {
  const response = await api({
    method: 'patch',
    url: `${SITES_ROOT}/${customerId}${SITES_ROOT}/${siteId}/data/sources/${dataSourceId}`,
    data,
  });

  return response.data;
};

const getCount = async (customerId: string, siteId: string) => {
  const response = await api({
    method: 'get',
    url: `${SITES_ROOT}/${customerId}${SITES_ROOT}/${siteId}/data/sources/count`,
  });

  return response.data;
};

export const DataSourceService = {
  add,
  addIntegralert,
  getAll,
  getById,
  edit,
  getCount,
};
